import { render } from "./GamePlayView.vue?vue&type=template&id=70271c95&scoped=true"
import script from "./GamePlayView.vue?vue&type=script&lang=js"
export * from "./GamePlayView.vue?vue&type=script&lang=js"

import "./GamePlayView.vue?vue&type=style&index=0&id=70271c95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70271c95"]])

export default __exports__